import * as React from 'react'
import { Link } from 'react-location'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import ArrowDropDownCircleOutlinedIcon from '@mui/icons-material/ArrowDropDownCircleOutlined'

type ComponentProps = {
  label: string
  email: string
  type: string
  id: number
}

const StyledAccordion = styled(Accordion)(() => ({
  borderRadius: '0',
  boxShadow: 'none',
  '& .MuiAccordionSummary-expandIconWrapper': {
    display: 'none',
  },
  '&:hover': {
    backgroundColor: '#f5f5f5',
    '& .MuiAccordionSummary-expandIconWrapper': {
      display: 'flex',
    },
  },
  '& .MuiAccordionDetails-root': {
    padding: '0px 10px 5px 10px',
  },
  '& .MuiAccordionSummary-content.Mui-expanded ,& .MuiAccordionSummary-root.Mui-expanded': {
    margin: 0,
    minHeight: 'unset',
  },
}))

function HeaderSearchOption(props: ComponentProps): JSX.Element {
  const { label, email, type, id } = props

  const [expand, setExpand] = React.useState(false)
  const toggleAccordion = () => {
    setExpand((prev) => !prev)
  }
  return (
    <StyledAccordion expanded={expand} key={label} sx={{ fontSize: 14 }}>
      <AccordionSummary
        sx={{ px: '10px' }}
        expandIcon={
          email ? (
            <ArrowDropDownCircleOutlinedIcon
              sx={{ color: '#b0b4ba', fontSize: 14 }}
              onClick={() => {
                toggleAccordion()
              }}
            />
          ) : null
        }
        aria-controls="panel1a-content"
        id={label}
      >
        <Link to={`/${type}/${id}`}>
          <Typography
            sx={{
              fontSize: 14,
              color: 'text.primary',
              textDecoration: 'none',
              '&:hover': { color: 'primary.main' },
            }}
          >
            {label}
          </Typography>
        </Link>
      </AccordionSummary>
      <AccordionDetails>
        <Typography
          sx={{
            color: 'text.primary',
            textDecoration: 'none',
            fontSize: 12,
            '&:hover': { color: 'primary.main' },
          }}
          component={'a'}
          href={`mailto:${email}`}
        >
          {email}
        </Typography>
      </AccordionDetails>
    </StyledAccordion>
  )
}

export default HeaderSearchOption
